import ClickAwayListener from "@mui/material/ClickAwayListener";
import { type FunctionComponent, useState } from "react";

import { StudentFormTooltips } from "scmp-app/components/posties/student-form/tooltip";
import { StyledTooltipsInfoArrow } from "scmp-app/components/posties/student-form/tooltip/styles";

import IconInfo from "./icon-info.svg";
import { Container, IconInfoContainer } from "./styles";
type Props = {
  className?: string;
  helperText?: null | string;
  title: null | string;
};
export const PostiesFormLabel: FunctionComponent<Props> = ({ className, helperText, title }) => {
  const [openTooltip, setOpenTooltip] = useState(false);
  const [isClick, setIsClick] = useState(false);

  return (
    <ClickAwayListener
      onClickAway={() => {
        setOpenTooltip(false);
        setIsClick(false);
      }}
    >
      <Container className={className}>
        <span>{title}</span>
        {helperText && (
          <IconInfoContainer
            onClick={() => {
              setOpenTooltip(true);
              setIsClick(true);
            }}
            onMouseLeave={() => {
              !isClick && setOpenTooltip(false);
            }}
            onMouseOver={() => {
              setOpenTooltip(true);
            }}
          >
            {openTooltip && <StyledTooltipsInfoArrow />}
            <IconInfo />
          </IconInfoContainer>
        )}
        {openTooltip && <StudentFormTooltips helperText={helperText} />}
      </Container>
    </ClickAwayListener>
  );
};

PostiesFormLabel.displayName = "PostiesFormLabel";
